import { Link, useLocation } from 'react-router-dom';

const breadcrumbLabels: Record<string, string> = {
  '': '首页',
  'categories': '分类',
  'articles': '文章',
  'about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs = [
    { label: '首页', path: '/', isLast: false },
    ...pathSegments.map((seg, index) => {
      const path = '/' + pathSegments.slice(0, index + 1).join('/');
      const isLast = index === pathSegments.length - 1;
      const label = breadcrumbLabels[seg] || seg;
      return { label, path, isLast };
    }),
  ];

  return (
    <nav aria-label="breadcrumb" className="w-full px-4 md:px-6 pt-20 pb-4">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center flex-wrap text-sm gap-1">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.path} className="flex items-center">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 mx-1 text-xs" />
              )}
              {crumb.isLast ? (
                <span className="text-foreground-700 font-medium">{crumb.label}</span>
              ) : (
                <Link to={crumb.path} className="text-foreground-500 hover:text-primary-500 transition-colors">
                  {crumb.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}